import React, { useState } from "react";
import { Navbar, Nav, Container, Offcanvas } from "react-bootstrap";
import {
  FaYoutube,
  FaInstagram,
  FaWhatsapp,
  FaFacebook,
  FaChevronRight,
} from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assests/logo.png";
const Header = () => {
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(false);

  const handleClose = () => setShowSidebar(false);
  const handleShow = () => setShowSidebar(true);

  const handleNavigation = (path) => {
    navigate(path);
    handleClose();
  };

  // Reusable Social Icons Component
  const SocialIconsList = ({ isMobile = false }) => (
    <div
      className={`d-flex align-items-center gap-3 ${isMobile ? "justify-content-center py-2" : ""}`}
    >
      <a
        href="https://www.instagram.com/bhaktivedmala/"
        className={
          isMobile
            ? "social-icon-gold text-white"
            : "desktop-social-icon text-muted"
        }
        target="_blank"
        rel="noreferrer"
      >
        <FaInstagram size={isMobile ? 22 : 18} />
      </a>
      <a
        href="https://www.youtube.com/@bhaktivedmala"
        className={
          isMobile
            ? "social-icon-gold text-white"
            : "desktop-social-icon text-danger"
        }
        target="_blank"
        rel="noreferrer"
      >
        <FaYoutube size={isMobile ? 24 : 20} />
      </a>
      <a
        href="https://www.facebook.com/Bhaktivedmala/"
        className={
          isMobile
            ? "social-icon-gold text-white"
            : "desktop-social-icon text-primary"
        }
        target="_blank"
        rel="noreferrer"
      >
        <FaFacebook size={isMobile ? 22 : 20} />
      </a>
      <a
        href="https://wa.me/"
        className={
          isMobile
            ? "social-icon-gold text-white"
            : "desktop-social-icon text-success"
        }
        target="_blank"
        rel="noreferrer"
      >
        <FaWhatsapp size={isMobile ? 22 : 20} />
      </a>
    </div>
  );

  return (
    <Navbar
      bg="white"
      expand="lg"
      sticky="top"
      className="p-0 shadow-sm border-bottom border-warning-subtle" /* py-2 ko p-0 (zero padding) kar diya */
      style={{
        height: "80px",
      }} /* Ek fixed navbar height di taaki logo control me rahe */
    >
      <Container className="h-100 d-flex align-items-center">
        {/* Brand Logo Section */}
        <Navbar.Brand
          className="m-0 p-0 d-flex align-items-center h-100 cursor-pointer" /* Margin/Padding 0 ki aur height 100% */
          style={{ color: "#431407", cursor: "pointer" }}
          onClick={() => handleNavigation("/")}
        >
          <img
            src={logo}
            alt="Vishnu Ji Maharaj Logo"
            className="navbar-premium-logo"
            style={{
              height: "100%" /* Poore navbar ki height le lega */,
              width: "auto" /* Aspect ratio kharab nahi hoga */,
              objectFit: "contain" /* Image compress ya stretch nahi hogi */,
              display: "block",
            }}
          />
        </Navbar.Brand>

        {/* Custom Burger Icon for Mobile */}
        <button
          className="navbar-toggler border-0 p-2 focus-none d-lg-none"
          type="button"
          onClick={handleShow}
          style={{ color: "#431407" }}
        >
          <span
            className="navbar-toggler-icon"
            style={{
              filter:
                "invert(11%) sepia(50%) saturate(3024%) hue-rotate(346deg) brightness(95%) contrast(98%)",
            }}
          ></span>
        </button>

        {/* Desktop View Menu & Premium Offcanvas Sidebar */}
        <Navbar.Offcanvas
          id="offcanvasNavbar-expand-lg"
          aria-labelledby="offcanvasNavbarLabel-expand-lg"
          placement="end"
          show={showSidebar}
          onHide={handleClose}
          className="premium-sidebar"
        >
          {/* Sidebar Header (Mobile Only) */}
          <Offcanvas.Header
            closeButton
            closeVariant="white"
            className="border-bottom border-secondary-subtle px-4 py-4 d-lg-none"
          >
            <Offcanvas.Title
              id="offcanvasNavbarLabel-expand-lg"
              className="d-flex flex-column"
              style={{
                height: "80px",
                color: "#fdfdfc",
              }}
            >
              <img
                src={logo}
                alt="Vishnu Ji Maharaj Logo"
                className="navbar-premium-logo"
                style={{
                  height: "100%" /* Poore navbar ki height le lega */,
                  width: "auto" /* Aspect ratio kharab nahi hoga */,
                  objectFit:
                    "contain" /* Image compress ya stretch nahi hogi */,
                  display: "block",
                }}
              />
            </Offcanvas.Title>
          </Offcanvas.Header>

          {/* Sidebar / Navbar Body */}
          <Offcanvas.Body className="d-flex flex-column justify-content-between p-lg-0 w-100 flex-lg-row align-items-lg-center">
            {/* Main Navigation Links */}
            <Nav className="mx-auto gap-lg-4 text-uppercase small fw-bold text-center mt-3 mt-lg-0">
              <Nav.Link
                as={Link}
                to="/"
                className="nav-link-custom premium-sidebar-link d-flex align-items-center justify-content-between justify-content-lg-center"
                onClick={handleClose}
              >
                <span>Home</span>
                <FaChevronRight
                  className="d-lg-none text-gold-muted"
                  size={12}
                />
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/video"
                className="nav-link-custom premium-sidebar-link d-flex align-items-center justify-content-between justify-content-lg-center"
                onClick={handleClose}
              >
                <span>Videos</span>
                <FaChevronRight
                  className="d-lg-none text-gold-muted"
                  size={12}
                />
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/katha"
                className="nav-link-custom premium-sidebar-link  d-flex align-items-center justify-content-between justify-content-lg-center"
                onClick={handleClose}
              >
                <span>✦ Katha</span>
                <FaChevronRight className="d-lg-none text-gold-muted" size={12} />
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/blogs"
                className="nav-link-custom premium-sidebar-link d-flex align-items-center justify-content-between justify-content-lg-center"
                onClick={handleClose}
              >
                <span>Blogs</span>
                <FaChevronRight
                  className="d-lg-none text-gold-muted"
                  size={12}
                />
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/contact"
                className="nav-link-custom premium-sidebar-link d-flex align-items-center justify-content-between justify-content-lg-center"
                onClick={handleClose}
              >
                <span>Contact</span>
                <FaChevronRight
                  className="d-lg-none text-gold-muted"
                  size={12}
                />
              </Nav.Link>
            </Nav>

            {/* Desktop View Social Icons (Perfectly aligned to the Right) */}
            <div className="d-none d-lg-flex align-items-center ms-auto">
              <SocialIconsList isMobile={false} />
            </div>

            {/* Mobile View Social Icons (Sidebar Bottom) */}
            <div className="mt-auto pt-4 border-top border-secondary-subtle w-100 d-lg-none">
              <p
                className="text-uppercase tracking-widest text-secondary text-center small mb-3"
                style={{ fontSize: "11px", color: "#a0a0a0 !important" }}
              >
                Connect with us
              </p>
              <SocialIconsList isMobile={true} />
            </div>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>

      {/* CSS Styles */}
      <style>{`
        /* Katha is a prominent primary menu CTA on desktop, normal nav row on mobile. */
        @media (min-width: 992px) {
          .katha-nav-link { background: #20483f!important; color:#fff8eb!important; border-radius:6px; padding:11px 21px!important; box-shadow:0 4px 14px #2a59472b; }
          .katha-nav-link:hover { background:#b08651!important; color:#fff!important; }
          .katha-nav-link::after { display:none!important; }
        }
        /* --- DESKTOP STYLES --- */
        .nav-link-custom {
          color: #2d3436 !important;
          transition: 0.3s;
          position: relative;
        }
        .nav-link-custom:hover {
          color: #DAA520 !important;
        }
        
        @media (min-width: 992px) {
          .nav-link-custom::after {
            content: '';
            position: absolute;
            width: 0;
            height: 2px;
            bottom: 0;
            left: 0;
            background-color: #DAA520;
            transition: 0.3s;
          }
          .nav-link-custom:hover::after {
            width: 100%;
          }
          /* Desktop Social Media Animations */
          .desktop-social-icon {
            transition: all 0.3s ease;
          }
          .desktop-social-icon:hover {
            color: #DAA520 !important;
            transform: translateY(-3px);
          }
        }

        /* --- PREMIUM MOBILE SIDEBAR STYLES --- */
        @media (max-width: 991.98px) {
          .premium-sidebar {
            background: linear-gradient(135deg, #f5cfc4 0%, #291102 100%) !important;
            width: 200px !important;
            box-shadow: -5px 0 25px rgba(0, 0, 0, 0.5) !important;
          }
          
          .text-gold {
            color: #DAA520 !important;
          }
          
          .text-gold-muted {
            color: rgba(218, 165, 32, 0.4);
            transition: 0.3s;
          }

          .premium-sidebar-link {
            color: rgba(255, 255, 255, 0.85) !important;
            padding: 1rem 1.25rem !important;
            margin-bottom: 0.5rem;
            border-radius: 8px;
            letter-spacing: 1.5px;
            font-size: 13px !important;
            background: rgba(255, 255, 255, 0.02);
            border-left: 3px solid transparent;
            transition: all 0.3s ease-in-out;
          }

          .premium-sidebar-link:hover {
            color: #ffffff !important;
            background: rgba(35, 32, 218, 0.1) !important;
            border-left: 3px solid #DAA520;
            padding-left: 1.5rem !important;
          }
          
          .premium-sidebar-link:hover .text-gold-muted {
            color: #DAA520;
            transform: translateX(3px);
          }

          .border-bottom {
            border-color: rgba(255, 255, 255, 0.08) !important;
          }
          .border-top {
            border-color: rgba(255, 255, 255, 0.08) !important;
          }

          /* Mobile Sidebar Social Icons Animation */
          .social-icon-gold {
            transition: all 0.3s ease;
            opacity: 0.75;
          }
          .social-icon-gold:hover {
            color: #DAA520 !important;
            transform: translateY(-4px);
            opacity: 1;
            filter: drop-shadow(0px 4px 8px rgba(218, 165, 32, 0.4));
          }
        }

        .focus-none:focus {
          box-shadow: none !important;
          outline: none !important;
        }
      `}</style>
    </Navbar>
  );
};

export default Header;
